import React from 'react';
import styled from 'styled-components';

import shortid from 'shortid';

import css from 'css';

const Wrapper = styled.div`
    position: relative;
    
    label {
        display:block;
        margin-bottom:5px;
    }

    ${props => props.error ? `
        input {
            border: 1px solid ${css.colors.red};
        }

        &:after {
            content: '${props.error}';
            color: ${css.colors.red};
            display:block;
            position: absolute;
            left: 0;
            bottom: -18px;
        }
    ` : ``}
`

export default ({ label, error, ...rest }) => {
    const id = shortid.generate();

    return (
        <Wrapper error={error} className={['input-wrapper', error ? 'error' : ''].join(' ')}>
            {label && <label htmlFor={id}>{label}</label>}
            <textarea id={id} type="text" {...rest} />
        </Wrapper>
    );
}




// WEBPACK FOOTER //
// ./src/partials/formElements/TextArea.js